const VACATION = 'vacation';
const COMPANY = 'company';

const getOptions = () => ([
	{ value: VACATION, label: 'enums.StayType.vacation' },
	{ value: COMPANY, label: 'enums.StayType.company' }
]);

export default {
	VACATION,
	COMPANY,

	getOptions,
}


// WEBPACK FOOTER //
// ./src/enums/StayType.js